import { deleteApiStripepaymentgatewayDeleteCardDetail } from "./deleteApiStripepaymentgatewayDeleteCardDetail";
import { getApiStripepaymentgatewayGetCardDetail } from "./getApiStripepaymentgatewayGetCardDetail";
import { getApiStripepaymentgatewayGetCompletePayments } from "./getApiStripepaymentgatewayGetCompletePayments";
import { getApiStripepaymentgatewayPaymentIntentDetail } from "./getApiStripepaymentgatewayPaymentIntentDetail";
import { getApiStripepaymentgatewayPublishableKey } from "./getApiStripepaymentgatewayPublishableKey";
import { getApiStripepaymentgatewaySetupIntentDetail } from "./getApiStripepaymentgatewaySetupIntentDetail";
import { postApiStripepaymentgatewaySaveCardDetail } from "./postApiStripepaymentgatewaySaveCardDetail";
import { postApiStripepaymentgatewaySaveCardTransLog } from "./postApiStripepaymentgatewaySaveCardTransLog";
import { postApiStripepaymentgatewaySaveTransactionDetail } from "./postApiStripepaymentgatewaySaveTransactionDetail";
import { postApiStripepaymentgatewayTransactionsSaveCard } from "./postApiStripepaymentgatewayTransactionsSaveCard";

export function stripePaymentGatewayController() {
  return {
    getApiStripepaymentgatewayPublishableKey,
    getApiStripepaymentgatewayPaymentIntentDetail,
    postApiStripepaymentgatewayTransactionsSaveCard,
    postApiStripepaymentgatewaySaveTransactionDetail,
    postApiStripepaymentgatewaySaveCardTransLog,
    getApiStripepaymentgatewaySetupIntentDetail,
    postApiStripepaymentgatewaySaveCardDetail,
    getApiStripepaymentgatewayGetCardDetail,
    deleteApiStripepaymentgatewayDeleteCardDetail,
    getApiStripepaymentgatewayGetCompletePayments,
  };
}
